module.exports = __webpack_public_path__ + "static/logo-synergistique-c3747898dbdc92556b9417b7a7b23cf0.png";